/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

window.OkInstagram = {
	initCbs: [],

	init(cb) {
		if (this.initialized) {
			if (cb) {
				cb();
			}
			return;
		}
		if (cb) {
			this.initCbs.push(cb);
		}
		if (this.initializing) {
			return;
		}
		this.initializing = true;

		// First check if their instagram token is stored on the server.
		return OkC.api(
			"/social/instagram/status",
			{
				api: 1,

				success: response => {
					if (response.ok) {
						return this.ready();
					} else {
						// Otherwise, open a window to authenticate
						return this.connect();
					}
				},
			},
		);
	},

	ready() {
		this.initializing = false;
		this.initialized = true;
		return this.initCbs.map(cb => cb());
	},

	// Connect your OkC account to instagram via a login window. Second arg will
	// mark the account for activation as well.
	connect(cb, arg2) {
		let activate;
		let onFailure;
		let onSuccess;
		if (_.isFunction(cb)) {
			onSuccess = cb;
			onFailure = _.noop;
			activate = arg2;
		} else if (_.isObject(cb)) {
			({ onSuccess, onFailure, activate } = cb);
		}

		if (onSuccess) {
			this.initCbs.push(onSuccess);
		}

		window.okinstagram_cb = token => {
			let data = { token };
			if (activate) {
				data.activate = true;
			}

			return OkC.post(
				"/social/instagram/connect",
				{
					api: 1,
					data,
				},
			)
				.then(() => {
					return this.ready();
				})
				.catch(e => {
					return onError(e);
				});
		};

		return window.open(
			"/okphotos/okinstagram.html",
			"okinstagram",
			"height=570,width=780"
		);
	},

	// Disconnect OKC account from instagram.
	disconnect(cb) {
		return OkC.delete(
			"/social/instagram/disconnect",
			{
				api: 1,

				success: () => {
					this.initialized = false;
					if (cb) {
						return cb();
					}
				},
			},
		);
	},

	// Mark account for showing instagram feed.
	activate(cb) {
		return OkC.post(
			"/social/instagram/activate",
			{
				api: 1,

				success: () => {
					if (cb) {
						return cb();
					}
				},
			},
		);
	},

	// Disable showing instagram feed. Keep credentials.
	deactivate(cb) {
		return OkC.post(
			"/social/instagram/deactivate",
			{
				api: 1,

				success: () => {
					if (cb) {
						return cb();
					}
				},
			},
		);
	},

	// Hit an instagram API path
	api(path, params, cb) {
		if (typeof params === "function") {
			cb = params;
			params = {};
		}

		cb = cb || ((...args) => args);

		return OkC.post(
			"/social/instagram",
			{
				api: 1,

				data: {
					path,
					params,
				},
			},
		)
			.then(cb)
			.catch(cb);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/okinstagram.js